import { bool, shape, string } from 'prop-types';
import {
  isBookingProcess,
  INQUIRY_PROCESS_NAME,
  PURCHASE_PROCESS_NAME,
  DIGITAL_PRODUCTS_FREE_PROCESS_NAME,
  DIGITAL_PRODUCTS_PAID_PROCESS_NAME,
  PRACTITIONER_CAMPAIGN_PROCESS_NAME,
  isPurchaseProcess,
  resolveLatestProcessName,
  getProcess,
} from '../../transactions/transaction';

import { getStateDataForBookingProcess } from './InboxPage.stateDataBooking.js';
import { getStateDataForInquiryProcess } from './InboxPage.stateDataInquiry.js';
import { getStateDataForPurchaseProcess } from './InboxPage.stateDataPurchase.js';
import { getStateDataForDigitalFreeProcess } from './InboxPage.stateDataDigitalFree.js';

export const stateDataShape = shape({
  processName: string.isRequired,
  processState: string.isRequired,
  actionNeeded: bool,
  isFinal: bool,
  isSaleNotification: bool,
});

// Translated name of the state of the given transaction
export const getStateData = params => {
  const { transaction } = params;
  const processName = resolveLatestProcessName(transaction?.attributes?.processName);
  const process = getProcess(processName);

  const processInfo = () => {
    const { getState, states } = process;
    const processState = getState(transaction);
    return {
      processName,
      processState,
      states,
    };
  };

  if (isPurchaseProcess(processName)) {
    return getStateDataForPurchaseProcess(params, processInfo());
  } else if (processName === DIGITAL_PRODUCTS_FREE_PROCESS_NAME) {
    return getStateDataForDigitalFreeProcess(params, processInfo());
  } else if (isBookingProcess(processName)) {
    // Corrected function call according to instructions
    return getStateDataForBookingProcess(params, processInfo());
  } else if (processName === INQUIRY_PROCESS_NAME) {
    return getStateDataForInquiryProcess(params, processInfo());
  } else if (processName === PRACTITIONER_CAMPAIGN_PROCESS_NAME) {
    return { ...processInfo(), isFinal: true };
  } else {
    return {};
  }
};
